<template lang="pug">
  v-card.py-4(flat)
    v-row(no-gutters align="center")
      v-col.pa-3.shrink
        intel-avatar(:code="parentMember.user.avatar_code" :id="parentMember.user.id" size="35")
      v-col.pr-2
        p.mb-1.p2.textColorHint--text {{ parentMember.role }}
        p.mb-1.s1.primary500--text {{ parentMember.user.first_name + ' ' + parentMember.user.last_name }}
        p.mb-1.p2.primary500--text Lead: {{ parentMember.total_leads }}
        p.mb-0.p2.primary500--text(v-if="authMember.role === 'Admin' || authMember.id == parentMember.id") Sales: {{ parentMember.total_sales | displayPrice }}
      v-col
        v-select(v-model="tier" outlined dense :items="companyTiers" item-text="name" item-value="id" hide-selected hide-details :class="valueChanged || focused ? 'value-changed' : ''")
</template>

<script>
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  name: 'MemberTierIndividualItem',
  props: {
    parentMember: {
      type: Object,
      default: () => {
        return {}
      }
    },
    companyTiers: {
      type: Array,
      required: true
    },
    focused: {
      type: Boolean
    },
    edited: {
      type: Object,
      default: null
    }
  },
  components: { IntelAvatar },
  data: (v) => ({
    isLoading: false,
    valueChanged: false,
    tier: v.parentMember.tier
  }),
  mounted() {
    if (this.edited) {
      this.tier = this.edited.tier
    }
  },
  watch: {
    tier: {
      handler(val) {
        if (val === this.parentMember.tier) {
          this.$emit('removeValue', { id: this.parentMember.id })
          this.valueChanged = false
        } else {
          this.$emit('editValue', { id: this.parentMember.id, tier: val })
          this.valueChanged = true
        }
      }
    }
  },
  computed: {
    authMember() {
      return this.$store.state.user.member
    }
  }
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
.value-changed {
  border: 1px solid var(--v-success500);
}
</style>